import { useMemo } from 'react';
import type { Selection } from '@nextui-org/react';
import { Select, SelectItem } from '@nextui-org/react';
import { TAGS } from '../tags';
import { getTagTopicCounts } from '../search';

const selectClassNames = {
    label: '!text-darkBlue dark:text-white/90 font-bold text-medium',
    innerWrapper: 'bg-transparent rounded-sm',
    base: 'rounded-md',
    trigger: 'bg-lightGrey/10',
};

// Tags and topic counts don't change at runtime, so build the option list once.
const TAG_OPTIONS = TAGS.map((tag) => {
    const topicCount = getTagTopicCounts()[tag.id] ?? 0;
    return { id: tag.id, label: `${tag.label} (${topicCount})` };
});

const EMPTY_SELECTION = new Set<string>();

interface ThematicTagSelectProps {
    value: string;
    onChangeValue: (tagId: string) => void;
}

export default function ThematicTagSelect({ value, onChangeValue }: ThematicTagSelectProps) {
    const selectedKeys = useMemo(() => (value ? new Set([value]) : EMPTY_SELECTION), [value]);

    const handleSelectionChange = (keys: Selection) => {
        const [firstKey] = keys === 'all' ? [] : Array.from(keys);
        onChangeValue(firstKey ? String(firstKey) : '');
    };

    return (
        <div className="mb-5 w-full rounded-lg bg-gradient-to-r from-lightOrange/50 to-darkBlue/50 p-1 font-semibold text-white">
            <Select
                className="flex w-full bg-lightGrey text-white"
                label="Search by tag"
                placeholder="Select a tag"
                radius="sm"
                selectedKeys={selectedKeys}
                onSelectionChange={handleSelectionChange}
                classNames={selectClassNames}
            >
                {TAG_OPTIONS.map((option) => (
                    <SelectItem key={option.id}>{option.label}</SelectItem>
                ))}
            </Select>
        </div>
    );
}
